// Core navigation components and utilities
// SplashScreenController removed - splash route handles splash screen timing

